<template>
    <div class="p-relative">
        <v-form v-if="commentsLoaded" class="wrapperForm" ref="form" lazy-validation>
            <v-row no-gutters>
                <v-col cols="12" sm="12" md="12" class="d-flex flex-column">
                    <v-card class="comments-list-v-card" flat>
                        <v-card-text v-if="comments.length">
                            <div class="dialogWrapper">
                                <!-- Облачка чата -->
                                <template v-for="(comment, index) in comments">
                                    <div :key="comment.Id" :class="[ getCommentClass(comment), (index > 0 && comments[index - 1].AuthorId == comment.AuthorId) ? 'noCommentDecor' : '' ]">

                                        <i v-if="(((index > 0 && comments[index - 1].AuthorId != comment.AuthorId) || index == 0) && comment.AuthorPhoto == '') || (comment.AuthorPhoto == '' && ((index > 0 && comments[index - 1].AuthorId != comment.AuthorId) || index == 0))"
                                            class="fas fa-user-circle personCommentNoPhoto"
                                            @click="produceGlobalEvent(comment.AuthorId)">
                                        </i>                                        
                                        <v-img v-if="((index > 0 && comments[index - 1].AuthorId != comment.AuthorId) || index == 0) && comment.AuthorPhoto != ''"
                                            :src="comment.AuthorPhoto"
                                            height="40"
                                            max-width="40"
                                            class="rounded-circle personCommentPhoto"
                                            @click="produceGlobalEvent(comment.AuthorId)"
                                        >
                                        </v-img>

                                        <!-- Заголовок комментария -->
                                        <div class="d-title d-flex">

                                            <!-- Автор комментария -->
                                            <div v-if="!isAttachmentMessageVisible(comment) && ((index > 0 && comments[index - 1].AuthorId != comment.AuthorId) || index == 0)">
                                                {{ comment.AuthorName }} ({{comment.EnterpriseName}})
                                            </div>

                                            <!-- Удалить комментарий-вложение -->
                                            <div
                                                v-if="(!comment.IsNew && comment.Attachment && comment.AuthorId == userInfo.WorkplaceId) || isAttachmentMessageVisible(comment)"
                                                class="dialog-file-actions ml-auto"
                                            >
                                                <span 
                                                    v-tooltip.left-center="$t('Удалить')"
                                                    @click.stop="deleteAttachment(comment)"
                                                >
                                                    <i class="fas fa-times dark-gray-color"></i>
                                                </span>
                                            </div>

                                        </div>
                                        
                                        <!-- Тело (вложение/текст) комментария -->
                                        <template v-if="comment.Attachment">
                                            <v-img
                                                v-if="isPicture(comment.Attachment.Extension)"
                                                contain
                                                :src="imgPreviewURL(comment.Attachment.Id, comment.Attachment.Name)"
                                                lazy-src="@/assets/placeholder-png-image.png"
                                                height="100"
                                                width="100"
                                                @click="loadAttachment(comment.Attachment)"
                                                class="cursor-pointer"
                                                transition="scale-transition"
                                            >
                                            </v-img>
                                            <v-btn
                                                v-else
                                                class="card-link-text btn-as-link"
                                                @click="loadAttachment(comment.Attachment)"                                            
                                                text
                                                plain
                                                :disabled="isAttachmentProgressVisible(comment)"
                                                v-tooltip.top-center="comment.Attachment.Name"
                                            >
                                                {{ truncateMiddle(comment.Attachment.Name, 35) }}
                                            </v-btn>
                                        </template>
                                        <div v-else class="d-content">
                                            {{ comment.CommentText }}
                                        </div>
                                        
                                        <!-- Футер комментария -->
                                        <div class="d-flex">

                                            <div>
                                                <!-- Текст ошибки при загрузке -->
                                                <div 
                                                    v-if="isAttachmentMessageVisible(comment)"    
                                                    class="dialog-file-err-msg"
                                                >
                                                    {{ comment.Attachment.Message }}
                                                </div>
                                                <!-- Прогресс загрузки -->
                                                <div 
                                                    v-else-if="isAttachmentProgressVisible(comment)" 
                                                    class="dialogFileProgressWrap"
                                                >
                                                    <v-progress-linear
                                                        v-model="comment.Attachment.Progress"
                                                        color="#7fc23399"
                                                        height="2"
                                                    ></v-progress-linear>
                                                </div>
                                                <!-- Размер вложения -->
                                                <div v-else>
                                                    <span v-if="comment.Attachment">
                                                        {{ parseInt(commentAttachmentLength(comment)) ? `${(parseFloat(commentAttachmentLength(comment)) / (1024 * 1024)).toFixed(2)} ${$t('МБ')}` : '-' }}
                                                    </span>    
                                                </div> 
                                            </div>

                                            <!-- Дата комментария -->
                                            <div class="ml-auto">
                                                {{ formatDate(comment.CommentDate, 'DD.MM.YYYY HH:mm') }}
                                            </div>
                                        </div>
                                       
                                    </div>
                                </template>
                            </div>
                        </v-card-text>
                        <v-card-text class="no-comments-label" v-else>
                            {{ $t('В_этом_чате_нет_сообщений') }}
                        </v-card-text>
                    </v-card>

                    <!-- Панель действий -->
                    <template>
                        <div class="event-comment-send-panel">
                            
                            <!-- Ввод текста комментария -->
                            <v-text-field
                                v-model="newCommentText"
                                hide-details
                                required
                                solo
                                flat
                                dense
                                @keydown.enter="handleEnterTextarea"
                            >
                                <template v-slot:prepend>
                                    <v-icon
                                        :disabled="savingComment || loadingAttachments.length > 0"
                                        @click="onAddFileClick"
                                    >
                                        fas fa-paperclip
                                    </v-icon>
                                </template>
                                <template v-slot:append>
                                    <v-icon
                                        v-if="!savingComment && loadingAttachments.length == 0"
                                        @click="addComment"
                                    >
                                        fas fa-paper-plane
                                    </v-icon>
                                    <v-progress-circular
                                        v-else
                                        :size="20"
                                        :width="2"
                                        indeterminate
                                        color="#a94442"
                                    ></v-progress-circular>
                                </template>
                            </v-text-field>

                        </div>
                    </template>

                </v-col>
            </v-row>
        </v-form>
        <v-overlay v-else absolute>
            <v-progress-circular
                indeterminate
                size="40"
                width="2"
                color="#a94442"
            ></v-progress-circular>
        </v-overlay>

        <CommentPicturePreview ref="CommentPicturePreviewRef" />
        
        <!-- Для загрузки файлов -->
        <input
            type="file"
            style="display: none"
            ref="inputFileToChat"
            multiple
            @change="onInputFileToChatChange"
        />

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Axios from 'axios';

import { httpAPI } from "@/api/httpAPI";
import CommentPicturePreview from '@/components/global/dialogs/CommentPicturePreview';
import sys from '@/services/system';

export default {
    name: "MeetingDetailPanelChat",
    components: {
        CommentPicturePreview
    },
    props: {
        meeting: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {
            pictureExtensions: ['jpg', 'jpeg', 'gif', 'png', 'apng', 'svg', 'bmp'],
            newCommentText: null,
            savingComment: false,
            commentsLoaded: false,
            comments: [],

            loadingAttachments: [],

            updater: null
        }
    },
    computed: {
        ...mapGetters('global/auth', { userInfo: 'getUserInfo' }),
    },
    methods: {
        handleEnterTextarea (e) {
            if (e.ctrlKey)
                this.addComment();
        },
        async addComment() {
            if (!this.newCommentText) return;

            let lines = this.newCommentText.split('\n');
            let tmp = [];

            for (var i = 0; i < lines.length; i++) {
                let trimmedLine = lines[i].trim();

                if (trimmedLine.length > 0)
                    tmp.push(trimmedLine);
            }

            let text = tmp.join('\n');

            if (text.length <= 0) {
                this.newCommentText = null;
                return;
            }
            
            this.savingComment = true;

            try {                
                let commentInfo = {
                    id: this.meeting.id,
                    commentText: text
                }

                let response = await httpAPI({
                    url: `api/plannedevent/addcomment`,
                    method: 'POST',
                    data: { Content : JSON.stringify(commentInfo) },
                    headers: { 'isCommon': true },
                });

                if (response)
                    await this.updateComments();
            }
            catch(exception) {
                console.log(exception);
            }
            finally {
                this.newCommentText = null;
                this.savingComment = false;
            }
        },
        onAddFileClick() {
            this.$refs.inputFileToChat.click();
        },
        async onInputFileToChatChange(e) {
            await Promise.all(Array.from(e.target.files).map( async (f) => {
                let currentTimeStamp = await this.$store.dispatch('documents/references/getTimestamp');
                let attachment = sys.prepareAttachment(f, this.comments);
                
                let comment = {
                    Id: sys.generateUUID(),
                    AuthorId: this.userInfo?.WorkplaceId,                    
                    AuthorName: this.userInfo?.UserName,
                    EnterpriseName: this.userInfo?.EnterpriseName,
                    CommentDate: sys.dateFormat(currentTimeStamp, 'DD.MM.YYYY HH:mm:ss'),
                    Attachment: attachment,
                    IsNew: true
                };

                this.loadingAttachments.push(comment);

                if (!this.comments.find(x => x.id == comment.Id))
                    this.comments.push(comment);
                
                if (attachment.Message)
                    this.deleteLoadingAttachment(comment.Id);
                
                let formData = new FormData();
                formData.append('file', f);

                try
                {
                    let response = await httpAPI({
                        url: `/api/plannedevent/savecommentattachment?id=${this.meeting.id}&fileName=${attachment.Name}&fileSize=${attachment.Length}`,
                        method: 'POST',
                        data: formData,
                        headers: { 'Content-Type': 'multipart/form-data', 'isCommon':  true},
                        onUploadProgress: (progressEvent) => {
                            let index = this.loadingAttachments.indexOf(this.loadingAttachments.find(i => i.Id == comment.Id));
                            let progress = `${Math.trunc((100/progressEvent.total)*progressEvent.loaded)}%`;

                            if (attachment.Progress != progress)
                                this.$_.set(this.loadingAttachments, `[${index}].Attachment.Progress`, progress);                           
                        },
                        cancelToken: attachment.CancelTokenSource.token,
                        skipErrorHandler: true
                    });

                    if (response.data.Success && response.data.Payload.Result == "OK") {
                        this.deleteLoadingAttachment(comment.Id);
                        comment.Attachment = response.data.Payload.Data.Object.Attachment;
                        comment.Id = response.data.Payload.Data.Object.Id;
                        delete comment.IsNew;
                    }
                    else {
                        comment.Attachment.Message = response.data.Success ? response.data.Payload.Message : response.data.Message;
                        delete comment.Attachment.Progress;
                        delete comment.IsNew;
                        this.deleteLoadingAttachment(comment.Id);
                    }
                }
                catch (ex)
                {
                    comment.Attachment.Message = Axios.isCancel(ex) ? this.$t('Загрузка_отменена') : this.$t('Ошибка_загрузки_файла');
                    delete comment.Attachment.Progress;
                    delete comment.IsNew;                    
                    this.deleteLoadingAttachment(comment.Id);
                    attachment.CancelTokenSource?.cancel();
                }
            }));
            
            e.target.value = null;
        },
        deleteLoadingAttachment(commentId) {
            var item = this.loadingAttachments.find(i => i.Id == commentId);

            if (!item) return;

            this.loadingAttachments.splice(this.loadingAttachments.indexOf(item), 1);
        },
        isAttachmentMessageVisible(comment) {
            return !!comment.Attachment?.Message
        },
        isAttachmentProgressVisible (comment) {
            return !!comment.Attachment?.Progress
        },
        commentAttachmentLength(comment) {
            return comment.Attachment?.Length
        },
        isPicture(extension) {
            if (extension)
                return this.pictureExtensions.includes(extension.replace('.', ''));
            
            return false;
        },
        imgPreviewURL(id, name) {
            let encodedKey = this.userInfo.Token.replaceAll('+', '.').replaceAll('/', '_').replaceAll('=', '-');
            return `api/download/attachment-from-source?id=${id}&name=${name}&token=${encodedKey}&height=100&width=100&common=true`;
        },
        getCommentClass(comment) {
            return comment.AuthorId == this.userInfo.WorkplaceId ? 'dialog dialog-2 dialog-50' : 'dialog dialog-1 dialog-50';
        },
        formatDate(date, format){
            let dateMoment = this.$moment(date, 'DD.MM.YYYY HH:mm:ss');

            if (dateMoment != null && dateMoment.isValid()) {
                return dateMoment.format(format);            
            }

            return null;
        },
        produceGlobalEvent(id) {
            if (!id) return;

            this.$eventBus.$emit('show-workplace-information', id);
        },
        async deleteAttachment(comment) {
            if (comment.Attachment?.Message) {
                await this.updateComments();
                return;
            }

            this.$notify.confirm(
                this.$t('Вы_действительно_хотите_удалить_вложение_filename?.message', { filename: comment.Attachment.Name }),
                async () => 
                {
                    let response = await httpAPI({
                        url: `api/plannedevent/deletecomment?id=${comment.Id}&attachmentId=${comment.Attachment.Id}&plannedMeetingId=${this.meeting.id}`,
                        method: 'GET',
                        headers: { 'isCommon': true }
                    });

                    if (response)
                        await this.updateComments();
                }
            );
        },
        async loadAttachment(item) {
            //если формат вложения поддерживает предпросмотр - открываем в модальном окне
            if (this.pictureExtensions.includes(item.Extension.replace('.', ''))) {
                let encodedKey = this.userInfo.Token.replaceAll('+', '.').replaceAll('/', '_').replaceAll('=', '-');
                let url = `api/download/attachment-from-source?id=${item.Id}&name=${item.Name}&token=${encodedKey}&common=true`;
                await this.$refs.CommentPicturePreviewRef.open(url, item);
                return;
            }

            this.$eventBus.$emit('on-download-file', { id: item.Id, name: item.Name });
        },
        async updateComments(withLoading) {
            if (withLoading)
                this.commentsLoaded = false;

            let response = await httpAPI({
                url: `api/plannedevent/comments/${this.meeting.id}`,
                method: 'GET',
                headers: { 'isCommon': true },
            });

            let persistentComments = response?.data?.Payload.map(x => ({ ...x, IsActive: false })) ?? [];
            this.comments = persistentComments.concat(this.loadingAttachments);

            if (withLoading)
                this.commentsLoaded = true;
        },
        truncateMiddle(text, maxLength = 50) {
            if (!text || text.length <= maxLength) return text;
            
            const half = Math.floor((maxLength - 3) / 2); // Вычисляем половины с учетом троеточия
            return text.slice(0, half) + '...' + text.slice(-half);
        }
    },
    created() {
        this.updater = setInterval(() => this.updateComments(), 10000);
        this.updateComments(true);
    },
    beforeDestroy() {
        clearInterval(this.updater);
        this.updater = null;
    }
}
</script>